/*
作者：刘清政（llnb）
时间：2021/5/5
作用：
*/

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
    state: {
        menuList: [],
        permList: [],
        hasRoutes: false,
        editableTabsValue: 'TeacherIndex',
        editableTabs: [{
            title: '首页',
            name: 'TeacherIndex',
        }]
    },
    mutations: {
        setMenuList(state, menus) {
            state.menuList = menus
        },
        setPermList(state, perms) {
            state.permList = perms
        },
        changeRouteStatus(state, hasRoutes) {
            state.hasRoutes = hasRoutes
        },
        addTab(state, tab) {
            let index = state.editableTabs.findIndex(e => e.name === tab.name)
            if (index === -1) {
                state.editableTabs.push({
                    title: tab.title,
                    name: tab.name,
                });
            }
            state.editableTabsValue = tab.name;
        },
        resetState: (state) => {
            state.menuList = []
            state.permList = []
            state.hasRoutes = false
            state.editableTabsValue = 'TeacherIndex'
            state.editableTabs = [{
                title: '首页',
                name: 'TeacherIndex',
            }]
        }
    },
    actions: {},
}
